import React, { Component, useEffect, useState } from "react";
import { Button, Icon } from "tabler-react";
import { Crud_Catalogos } from '../../herramientas/Crud_Catalogos';
import ModalLayout from "../../components/ModalLayout.react";
import { GetRoles } from "../../herramientas/JWT";
import CanalesForm  from "./CanalesForm";
import { TablePageable } from "../../Helpers";
import LiveVideo from "../../components/LiveVideo";
const  CanalesList =({ dispositivo })=> {
  const [canal, setCanal]= useState({});
  const [canales, setCanales]= useState([]);
  const [hiddenModals, setHiddenModals]= useState(false);
  useEffect(()=>{
    Crud_Catalogos("canales/"+ dispositivo.id, "get", "", "").then((returnVal) => {
      setCanales(returnVal);
    }).catch(err =>{ alert("A ocurrido un error")});    
  },[]);

  return (
    <div className="content">
      <div className="row">
        <div className="col-6">
          <TablePageable
            titulo={
              <div className="row">
                <div className="col"><h5>Canales</h5></div>
                <div>
                <div hidden={ !GetRoles().includes("root", "hola")}>
                    <ModalLayout
                      tamanio={"50%"}
                      hiddenModal={ hiddenModals }
                      Fclose={()=> setHiddenModals(!hiddenModals)}
                      title= "Nuevo"
                      name= {<Button pill size="sm" outline color="primary"><Icon name="plus"/></Button>}
                      formulario= {
                        <CanalesForm
                          accion="nuevo"
                          dispositivo={ dispositivo }
                          elementos={ null }
                          catalogo= { "canales" }
                        />
                      }
                    />                       
                </div>
                </div>
              </div>
            }
            lista= { canales }
            columnas={
              [
                { columna: "editar", label: "Editar",
                  form: (e)=>
                  <span className="badge" hidden={!GetRoles().includes("root", "hola")}>
                    <ModalLayout
                      tamanio={"50%"}
                      hiddenModal={ hiddenModals }
                      Fclose={()=> setHiddenModals(!hiddenModals)}
                      title= "Modificar"
                      name= {<Button pill size="sm" outline color="primary"><Icon name="edit"/></Button>}
                      formulario= {
                        <CanalesForm
                          accion="modificar"
                          dispositivo={ dispositivo }
                          elemento={ e }
                          catalogo= { "canales" }
                        />
                      }
                    />
                  </span>                  
                },
                { columna: "canal", label: "Canal" },
                { columna: "nombre", label: "Nombre" },
                { columna: "descripcion", label: "Descripción" },
              ]
            }
            id= "canal"
            selected={(e)=>{
              setCanal(e);
            }}
            //csvname= {"Canales"}
            //resaltarFuncion={(e)=> incidencias.filter(i => i.incidencia.id === e.id  ).length ? true: false}
            //resaltarColor={"rgba(58, 223, 149, 0.25)"}
            //paginacion={true}
            elementosPorPagina={15}
          />
        </div>
        <div className="col-6">
          <LiveVideo
            dispositivo= {dispositivo.id}
            token= {"KKLHjlHke_tqcw9xlHC2Y3dm0D9QmFwA16buOxl8yhk="}
            canal= {canal.canal? canal: null }
          />
        </div>
      </div>
    </div>
  );
}
export default CanalesList;
